import homePage from "./HomePage.module.css";
import { getTilesByUserType } from "../../constants/tilesConfig";
import TileRenderer from "../Control/TileRenderer";
import { useAuth } from "../../context/GlobalContext";
const validTiles = [18, 19, 20, 36]
const QualityDepartment = () => {
  const { state } = useAuth();
  const access = state.user?.access || [];

  if (state.user?.userType === 2) {
    const adminTiles = getTilesByUserType(2).filter(tile => tile.hideForUsers);


    return (
      <>
        <main className={`${homePage.container} ${homePage.main}`}>
          {adminTiles.filter((tile) => !validTiles.includes(tile.id)).map(tile => {
            return (
              <TileRenderer
                key={tile.id}
                tile={tile}
              />
            );
          })}

        </main>
      </>
    );
  } else {
    return (
      <div>
        <h1>Page Not Found</h1>
      </div>
    );
  }
}

export default QualityDepartment
